import React, { useContext, useState } from 'react';
import { LanguageContextData, ProceedableProps } from './types';
import { textValues, LanguageContext } from './utils';

const Disclaimer = ({ proceed }: ProceedableProps) => {
  const { language } = useContext<LanguageContextData>(LanguageContext);
  const [ acknowledged, setAcknowledged ] = useState<boolean>(false);
  return (
    <article>
      <h1>{ textValues[language]['disclaimer'] }</h1>
      <div dangerouslySetInnerHTML={{ __html: textValues[language]['disclaimerText'] }} />
      
      <div className='row'>
        <div>
          <input id='checkbox' type='checkbox' onChange={ (e) => setAcknowledged(v => !v) } /><label htmlFor='checkbox' >{ textValues[language]['disclaimerCheckbox'] }</label>
        </div>
        <button disabled={ !acknowledged } onClick={(e) => { e.preventDefault(); proceed() }}>{ textValues[language]['disclaimerButton'] }</button>
      </div>
    </article>
  );
};

export default Disclaimer;